import { useAppSelector } from '@/store/store-hooks'
import type { RootState } from '@/store/store'
import { selectMatterById, selectMatterMembers } from '@/matter/store/selectors'
import { getMemberDisplayName } from '@/collaboration/utils/members'

/** The matter owner's display name, or null when it can't be resolved from the member list. */
export function useMatterOwnerName(matterId: string): string | null {
  const matter = useAppSelector((state: RootState) => selectMatterById(state, { matterId }))
  const members = useAppSelector((state: RootState) => selectMatterMembers(state, matterId))
  const owner = matter ? members.find((member) => member.user_id === matter.user_id) : undefined
  return owner ? getMemberDisplayName(owner) : null
}
